import React from 'react';
import { Button, Form } from 'react-bootstrap';
import Alert from 'react-bootstrap/Alert';

import LoadingOverlay from '../LoadingOverlay/index.jsx';

import { AjaxService } from '../../Services/Ajax/index.jsx';

import Authentication from '../../Utilities/Authentication/index.jsx';



class CheckoutIdentification extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      validated: false,
      loading: false,
      error: undefined,
      validation: {}
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.submitComplete = this.submitComplete.bind(this);
    this.onError = this.onError.bind(this);
    this.onEmailChange = this.onEmailChange.bind(this);
    this.onTermsChange = this.onTermsChange.bind(this);
  }

  /**
   * Check the change to the email address field, and indicate whether it's
   * "good" or not.
   */
  onEmailChange(event) {
    if (this.state.validated) {
      var input = event.target;

      var error;
      if (! input.checkValidity()) {
        error = input.validationMessage;
      }

      this.setState(function(oldState) {
        var oldValidation = oldState.validation;

        var newValidation = Object.assign({}, oldValidation);

        if (error) {
          newValidation.email = error;
        } else {
          if (newValidation.email) {
            delete newValidation.email;
          }
        }

        return { validation: newValidation };
      });
    }
  }

  /**
   * Check the change to the terms field, and indicate whether it's "good" or
   * not.
   */
  onTermsChange(event) {
    if (this.state.validated) {
      var input = event.target;

      var error;
      if (! input.checked) {
        error = 'You must accept the terms and condititions to continue';
      }

      this.setState(function(oldState) {
        var oldValidation = oldState.validation;

        var newValidation = Object.assign({}, oldValidation);

        if (error) {
          newValidation.terms = error;
        } else {
          if (newValidation.terms) {
            delete newValidation.terms;
          }
        }

        return { validation: newValidation };
      });
    }
  }

  onSubmit(event) {
    event.preventDefault();

    var newState = { validated: true };
    var form = event.currentTarget;

    // validate the form.
    var submitForm = true;
    var validation = {};
    var email = form.elements.email;
    if (! email.checkValidity()) {
      submitForm = false;
      validation.email = email.validationMessage;
    }
    var terms = form.elements.terms;
    if (! terms.checked) {
      submitForm = false;
      validation.terms = 'You must accept the terms and condititions to continue';
    }


    if (submitForm) {
      newState.loading = true;

      var formData = [];
      formData.push('email=' + encodeURIComponent(form.elements['email'].value));
      if (form.elements['terms'].checked) {
        formData.push('terms=1');
      }

      AjaxService.post('cs:checkout-identification', formData.join('&'))
        .then(this.submitComplete)
        .catch(this.onError);
    } else {
      newState.validation = validation;
    }

    this.setState(newState);
  }

  submitComplete(response) {
    if (response.error) {
      this.setState({ loading: false, error: response.message });
    } else {
      // do something.
      if (response.data) {
        // all good, refresh the window
        if (response.data.success) {
          window.location.href = window.location.href;
        } else {
          this.setState({
            loading: false,
            validation: response.data.validation
          });
        }
      } else {
        this.setState({
          loading: false,
          error: 'Submit was successful, but no response was received'
        });
      }
    }
  }

  onError(error) {
    console.error(error);
    this.setState({ loading: false, error: error.message });
  }

  render() {
    var content = [];

    if (this.state.error) {
      content.push(
        <Alert key="error" variant="danger">
          <Alert.Heading>Error:</Alert.Heading>
          {this.state.error}
        </Alert>
      );
    }

    content.push(
      <div key="content">
        <LoadingOverlay disabled={! this.state.loading}>
          <Form noValidate onSubmit={this.onSubmit}>
            {this.emailField()}
            {this.termsField()}
            <Form.Group>
              <Button block type="submit">Get started</Button>
            </Form.Group>
          </Form>
          <p className="text-center mb-0 mt-4">
            Already have an account? <a href={Authentication.getLoginUrl()}>Sign in</a>
          </p>
        </LoadingOverlay>
      </div>
    );


    return content;
  }

  emailField() {
    var emailProps = {
      name: 'email',
      type: 'email',
      id: 'email',
      placeholder: 'you@mail.com',
      required: true,
      onChange: this.onEmailChange
    };
    var feedback;

    if (this.state.validated) {
      if (this.state.validation.email) {
        emailProps.isInvalid = true;
        feedback = (
          <Form.Control.Feedback type="invalid">{this.state.validation.email}</Form.Control.Feedback>
        );
      } else {
        emailProps.isValid = true;
      }
    }


    return (
      <Form.Group>
        <Form.Label htmlFor="email">Email address</Form.Label>
        <Form.Control {...emailProps} />
        {feedback}
      </Form.Group>
    );
  }

  termsField() {
    var props = {
      custom: true,
      type: 'checkbox',
      id: 'terms',
      name: 'terms'
    };
    var inputProps = {
      onChange: this.onTermsChange
    };
    var feedback;

    if (this.state.validated) {
      if (this.state.validation.terms) {
        inputProps.isInvalid = true;
        feedback = (
          <Form.Control.Feedback type="invalid">{this.state.validation.terms}</Form.Control.Feedback>
        );
      } else {
        inputProps.isValid = true;
      }
    }


    return (
      <Form.Group>
        <Form.Check {...props}>
          <Form.Check.Input {...inputProps} />
          <Form.Check.Label>
            I agree to <a href="/terms/" target="_blank">terms of use</a> and <a href="/privacy-policy/" target="_blank">privacy policy</a>
          </Form.Check.Label>
          {feedback}
        </Form.Check>
      </Form.Group>
    );
  }
}


export default CheckoutIdentification;

